import { Component } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { Deferred } from '@ebeihilfe/core';
import {
  Antrag, ConfirmationConfig, ConfirmationStepBase, EinreichungComponentType, EinreichungStep, EinreichungStepResultType,
} from '@ebeihilfe/einreichung-old';

@Component({
  selector: 'einreichung-confirmation-step',
  template: `
    <ebeihilfe-confirmation-step [fields]="fields" (submitEmitter)="submit($event)" (goBackEmitter)="goOneStepBack()"></ebeihilfe-confirmation-step>`,
  styles: [''],
  standalone: false
})
export class EinreichungsConfirmationComponent extends ConfirmationStepBase implements EinreichungComponentType<EinreichungsConfirmationComponent> {
  public component = EinreichungsConfirmationComponent;
  public fieldConfig: ConfirmationConfig[] = [
    {
      content: _('new_antrag.confirmation.header'),
      typeOfText: 'header',
    },
    {
      content: _('new_antrag.confirmation.text'),
      typeOfText: 'text',
    },
    {
      content: _('new_antrag.confirmation.text1'),
      typeOfText: 'text',
    },
  ];
  public prio = EinreichungStep.UPLOADING - 1;

  public handle(antrag: Antrag,
    instance: EinreichungsConfirmationComponent,
    work: Deferred<EinreichungStepResultType>): Promise<EinreichungStepResultType> {
    instance.antrag = antrag;
    instance.work = work;
    return instance.work;
  }
}
